import React from 'react';

import { SimpleTooltip } from '@/components/ui/tooltip';
import { formatAggregateScore } from '@/pages/qc/utils';
import { cn } from '@/utils';

interface LastFiveDotsProps {
  scores: number[];
}

const dotClass = (score: number | null): string => {
  if (score == null) return 'bg-muted';
  if (score >= 0.9) return 'bg-positive-foreground';
  if (score >= 0.85) return 'bg-attention-foreground';
  return 'bg-critical-foreground';
};

const dotLabel = (score: number | null): string =>
  score == null ? 'No call' : formatAggregateScore(score);

export const LastFiveDots: React.FC<LastFiveDotsProps> = ({ scores }) => {
  const slots: (number | null)[] = [
    ...scores,
    ...Array(Math.max(0, 5 - scores.length)).fill(null),
  ].slice(0, 5);

  return (
    <div
      className="inline-flex items-center gap-1"
      aria-label={`Last calls: ${slots.map(dotLabel).join(', ')}`}
    >
      {slots.map((score, idx) => (
        <SimpleTooltip key={idx} content={dotLabel(score)} side="top">
          <span className={cn('h-2.5 w-2.5 rounded-full inline-block', dotClass(score))} />
        </SimpleTooltip>
      ))}
    </div>
  );
};
